import {IProposal} from '@bidmii/common/lib/server/IServerApi';
import * as Sentry from '@sentry/react';

export default function getTotalStages(proposal: IProposal) {
  if (!proposal || !proposal?.stages) {
    return [];
  }
  const stages = proposal ? [...proposal.stages] : [];
  try {
    proposal?.addons.forEach((addOn: $TSFixMe) => {
      if (addOn.stages && addOn.stages.length > 0) {
        addOn.stages.forEach((stage: $TSFixMe) => stages.push(stage));
      }
    });
  } catch (err) {
    Sentry.withScope(function (scope) {
      scope.setTag('section', 'getTotalStages.ts getTotalStages()');
      Sentry.captureException(err);
    });
  }

  return stages;
}
